import React, { useRef } from 'react';
import './whyUs.css';
import { motion, useInView } from "framer-motion";

function WhyUs() {

  const whyUsCard = useRef(null);
  const whyUsCardView = useInView(whyUsCard);


  return (
    <section className="whyUsSection">
      <div className="container whyusContainer">

        <div className="whyUsItem">
          <div className="whyUsCircle">1</div>
          <motion.p
            ref={whyUsCard}
            initial={{ opacity: 0 }}
            animate={whyUsCardView ? { opacity: 1 , x:0 } : { opacity: 0,x: 30 }}
            transition={{ duration: 1 }}
          >
            <div className="whyUsText">
              لأننا نؤمن بأن العميل يستحق أن يرى رؤيته تتحول إلى واقع بسرعة ووضوح.
            </div>
          </motion.p>
        </div>

        <div className="whyUsItem">
          <div className="whyUsCircle">2</div>
          <motion.p
            ref={whyUsCard}
            initial={{ opacity: 0 }}
            animate={whyUsCardView ? { opacity: 1 , x:0 } : { opacity: 0,x: 30 }}
            transition={{ duration: 1 }}
          >
            <div className="whyUsText">
              نختصر عليه الطريق باستخدام أدوات وتقنيات فنية ومبتكرة، تتيح له تصور النتيجة النهائية خلال دقائق.
            </div>
          </motion.p>
        </div>

        <div className="whyUsItem">
          <div className="whyUsCircle">3</div>
          <motion.p
            ref={whyUsCard}
            initial={{ opacity: 0 }}
            animate={whyUsCardView ? { opacity: 1 , x:0 } : { opacity: 0,x: 30 }}
            transition={{ duration: 1 }}
          >
            <div className="whyUsText">
              لا نعتمد فقط على البرامج، بل نوظّف مواد وخامات حقيقية، ونستخدم مخططات دقيقة توضع مباشرة على خامات مثل الخشب أو الهاي غلوس، لنمنح العميل فرصة لتخيّل النتيجة النهائية واتخاذ قراره بثقة تامة.
            </div>
          </motion.p>
        </div>

      </div>
    </section>
  );
}

export default WhyUs;
